<template>
    <section class="slice slice-list slice-list--default">
        <div class="slice-content">
            <ul class="slice-list__items">
                <li v-for="(item, index) in slice.items" :key="index" class="slice-list__item">
                    <PrismicRichText :field="item.item" />
                </li>
            </ul>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {getSliceComponentProps, PrismicRichText} from '@prismicio/vue';
    import type {ListSlice} from '@prismicio-types';

    type ListDefaultInZone = Extract<ListSlice, {variation: 'default'}>;
    defineProps(getSliceComponentProps<ListDefaultInZone>());
</script>

<style lang="scss">
    .slice-list {
        $article-max-width: 730px;

        &--default {
            .slice-list__items {
                margin-bottom: var(--joy-core-spacing-7);
                list-style: none;
                width: 100%;
                padding-left: 0;
                padding-right: 0;
                margin-left: auto;
                margin-right: auto;
            }

            .slice-list__item {
                position: relative;
                margin-bottom: var(--joy-core-spacing-6);
                font-size: 18px;

                &::before {
                    content: url('../checkCircle.svg');
                    height: 22px;
                    width: 22px;
                    position: absolute;
                    left: -30px;
                    top: 1px;
                }
            }

            .slice-content {
                max-width: $article-max-width;
                text-align: left;
                padding-left: 0;
                padding-right: 0;
            }
        }
    }

    .malt-strategy-theme .slice-list--default .slice-list__item::before {
        content: url('../checkCircleMs.svg');
    }
</style>
